<template>
<div id="page-song" class="container-fluid">
    <div class="row" :id="eid">
        <div class="col-xs-12 header">
            <div class="row">
                <div class="col-xs-12 top">
                    <div class="button button-center back" @click="back()"><i class="iconify icon:ic:round-keyboard-backspace"></i></div>
                    <div class="options"></div>
                    <div class="options"></div>
                </div>

                <div class="col-xs-12 p-h-0 cover">
                    <div class="image" :style="songPicture"></div>
                </div>

                <div class="col-xs-12 player">
                    <div class="row" v-if="!hasNoVideo">
                        <div class="col-xs-12">
                            <span v-show="!isPlaying" @click="playSong()">
                                <i class="iconify icon:ic:baseline-play-circle-filled-white btn-play" ></i>
                            </span>

                            <span v-show="isPlaying" @click="pauseSong()">
                                <i class="iconify icon:ic:sharp-pause-circle-outline btn-pause"></i>
                            </span>

                            <i class="iconify icon:ic:outline-skip-next btn-next"></i>
                            <i class="iconify icon:ic:outline-skip-previous btn-previous"></i>
                            <div class="clearfix"></div>
                        </div>

                        <div class="col-xs-12 track">
                            <div class="row">
                                <div class="col-xs-12">
                                    <span class="range-slider" :class="{'disabled': !isReady}">
                                        <span class="range-slider-inner">
                                            <input type="text" class="range-slider-hidden">
                                            <span class="range-slider-rail"></span>
                                            <span class="range-slider-fill"></span>
                                            <span class="range-slider-knob"></span>
                                        </span>
                                    </span>
                                </div>
                                <div class="col-xs-6 text-left elapsed" v-html="formatSeconds(track.time)"></div>
                                <div class="col-xs-6 text-right remaining" v-html="formatSeconds(track.duration)" v-if="isReady"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-else>
                        <br>
                    </div>
                </div>

                <div class="col-xs-12 info">
                    <p class="artist" v-html="song.artist"></p>
                    <p class="title" v-html="song.name"></p>

                    <p class="date-genre">{{ song.published_formatted }}&nbsp;&nbsp;&nbsp;{{ getGenres }}</p>
                    <p class="uploader" :class="{'followed': isFollowed}" v-html="song.uploader.name" @click="openUploader"></p><br>

                    <p class="label label-primary">Available for licensing</p>
                </div>
            </div>
        </div>

        <div class="col-xs-12 actions">
            <span @click="review('like')" class="button button-center btn-like" :class="{ 'selected': reviewTypeIs('like') }">
                <i class="iconify icon:ic:baseline-favorite-border"></i>
                <i class="iconify icon:ic:baseline-favorite"></i>
            </span>

            <div class="button button-center btn-add-playlist" @click="showPlaylistManager">
                <i class="iconify icon:ic:baseline-add-circle-outline"></i>
            </div>

            <span @click="review('dislike')" class="button button-center btn-dislike" :class="{ 'selected': reviewTypeIs('dislike') }">
                <i class="iconify icon:ic:baseline-block"></i>
                <i class="iconify icon:ic:baseline-block"></i>
            </span>

            <div class="clearfix"></div>
        </div>

        <div class="col-xs-12">
            <ul class="page-tabs">
                <li @click="changeTab('#statistics')" :class="{'active' : isTab('#statistics')}">Statistics</li>
                <li @click="changeTab('#messages')" :class="{'active' : isTab('#messages')}">Messages</li>
                <li @click="changeTab('#share')" :class="{'active' : isTab('#share')}">Share</li>
                <li @click="changeTab('#artwork', false)" :class="{'active' : isTab('#artwork')}">EPK</li>
                <li @click="changeTab('#lyrics', false)" :class="{'active' : isTab('#lyrics')}">Lyrics</li>
                <li @click="changeTab('#metadata', false)" :class="{'active' : isTab('#metadata')}">Metadata</li>
            </ul>
        </div>

        <div class="col-xs-12 tab-content no-padding">
            <statistics-tab v-if="isTabRendered('#statistics')" v-show="isTab('#statistics')" :song="song"></statistics-tab>
            <messages-tab-own v-if="isTabRendered('#messages') && isOwner" v-show="isTab('#messages')" :song="song"></messages-tab-own>
            <messages-tab-other v-if="isTabRendered('#messages') && !isOwner" v-show="isTab('#messages')" :song="song"></messages-tab-other>
            <share-tab v-if="isTabRendered('#share')" v-show="isTab('#share')" :song="song"></share-tab>
            <artwork-tab v-if="isTabRendered('#artwork')" v-show="isTab('#artwork')" :song="song"></artwork-tab>
            <lyrics-tab v-if="isTabRendered('#lyrics')" v-show="isTab('#lyrics')" :song="song"></lyrics-tab>
            <metadata-tab v-if="isTabRendered('#metadata')" v-show="isTab('#metadata')" :song="song"></metadata-tab>
        </div>

        <div class="clearfix"></div>

        <loader v-if="!song" color="ripple" size="250px"></loader>
    </div>
</div>
</template>

<script>
// import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';

export default {
    components: {
        // RangeSlider,
        'statistics-tab': require('@/components/Song/Show/Tab/Statistics.vue').default,
        'messages-tab-own': require('@/components/Song/Show/Tab/MessagesOwn.vue').default,
        'messages-tab-other': require('@/components/Song/Show/Tab/MessagesOther.vue').default,
        'share-tab': require('@/components/Song/Show/Tab/Share.vue').default,
        'artwork-tab': require('@/components/Song/Show/Tab/Artwork.vue').default,
        'lyrics-tab': require('@/components/Song/Show/Tab/Lyrics.vue').default,
        'metadata-tab': require('@/components/Song/Show/Tab/MetaData.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: {
        songId: {
            default: null,
        },
        disabled: {
            default: false,
        },
        token: {
            default: '',
        },
    },

    data() {
        return {
            eid: "page_song_"+ Math.random().toString(36).substr(2, 9),
            tab: {
                active:'#statistics',
                rendered: {
                    '#statistics': false,
                    '#messages': false,
                    '#share': false,
                    '#artwork': false
                }
            },
            song: {
                name: '&nbsp;',
                artist: '&nbsp;',
                uploader: {name: '&nbsp;'},
                genres: [],
            },
            isPlaying: 0,
            track: {
                time: 0,
                duration: 0,
                buffering: false,
                state: -1
            },
            sliderValue: 0
        }
    },

    mounted() {
        this.changeTab('#statistics', false);

        if (App.queryParams){
            this.song = App.queryParams;
            App.queryParams = false;
        }

        this.tab.active = this.$router.currentRoute.hash ? this.$router.currentRoute.hash : this.tab.active;
        this.tab.rendered[this.tab.active] = true;
        this.getSong();

        this.$root.$emit('hide-footer');

        this.$root.$on('currentSongPlaying', (id) => {
            if (this.song.id == id){
                this.$root.$on('currentSongStream', this.fnUpdateSeeker);
            }
        });

        this.$root.$on('request-access', () => {
            this.song.permission = true;
        });        
    },

    methods: {
        fnUpdateSeeker(duration, time, state){
            this.track.duration = duration;
            this.track.time = time;
            this.track.state = state;
        },

        openUploader() {
            App.queryParams = this.song.uploader;
            this.$router.push({path: '/profile/' + this.song.uploader.id});
        },        

        getSong() {
            this.$http.get(this.getSongEndpoint).then((success) => {
                success.data.data.permission = false;
                this.song = success.data.data;
                this.$root.$emit('requestCurrentSong');
                // this.initPlayer();
                console.log(this.song);
            });
        },

        formatSeconds(seconds){
            return moment("2015-01-01").startOf('day').seconds(seconds).format('mm:ss');
        },

        isTab(tab) {
            return this.tab.active == tab;
        },

        isTabRendered(tab) {
            return this.isLoaded ? this.tab.rendered[tab] : false;
        },

        changeTab(tab, scroll = true) {
            this.tab.active = tab;
            this.tab.rendered[tab] = true;

            this.$nextTick(() => {
                if (scroll){
                    this.scrollBottom();
                }else{
                    // $('main').animate({ scrollTop: 630}, 750);
                }
            });

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/song/" + tab.slice(1),
                'page_location': "/song/" + tab,
                'page_title' : `${ this.isOwner ? 'Own' : 'Other'} Song > ` + tab.charAt(1).toUpperCase() + tab.slice(2),
            });            
        },

        showPlaylistManager(){
            this.$root.$emit('showPlaylistManager', this.song);
        },

        playSong() {
            if (this.hasNoVideo) return;

            this.$root.$emit('mp-load-song', this.song, true);
            this.back();

            if (App.allowGtag) gtag('event', `play_song`, {
                'event_category' : 'song',
                'event_label' : `Play ${ this.isOwner ? 'own' : 'other user'} song from Song Page`
            });

            // // unitialized state .. we first load song
            // if (this.isPlaying === 0){
            //     this.isPlaying = true;
            //     this.$root.$emit('playSong', this.song, true);
            // // initialized state, we simply resume/play
            // }else{
            //     this.isPlaying = true;
            //     this.$root.$emit('playerAction', 'play');
            // }

            // this.$root.$on('currentSongStream', (duration, time, state) => {
            //     this.track.duration = duration;
            //     this.track.time = time;
            //     this.track.state = state;
            // });
        },

        pauseSong() {
            this.isPlaying = false;
            this.$root.$emit('playerAction', 'pause');
        },

        review(type) {
            navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
            if (navigator.vibrate) {
                navigator.vibrate(100);
            }

            if (this.song.review && this.song.review.type == type) return;

            var data = {
                review: type,
            };

            this.song.review = data.review;
            this.$http.post(this.reviewEndpoint, data).then((success) => {
                if (App.allowGtag) gtag('event', `${type}_song`, {
                    'event_category' : 'song',
                    'event_label' : `${ type.charAt(0).toUpperCase() + type.slice(1) } ${ this.isOwner ? 'own' : 'other user'} song`
                });
            });
        },

        reviewTypeIs(type) {
            return this.song.review == type;
        },

        isFollowed(){
            return this.song.artist_pick === 'followed';
        },

        isBlocked(){
            return this.song.artist_pick === 'blocked';
        },

        toggleFollow() {
            var pick = this.song.artist_pick === 'followed' ? 'unfollow' : 'follow';
            this.updatePick(pick);
        },

        toggleBlock() {
            var pick = this.song.artist_pick === 'blocked' ? 'unblock' : 'block';
            this.updatePick(pick);
        },

        updatePick(pick) {
            this.$http.post(this.updatePickEndpoint, { pick: pick }).then((success) => {
                this.song.artist_pick = success.data.data.status;
                this.$root.$emit('pickUpdated', this.song.artist_pick, this.song.uploader.id);
            });
        },

        isPublished(){
            return this.song.released;
        },

        isReleased(){
            return this.song.public;
        },

        back(){
            setTimeout(() => {
                this.$router.go(-1);
            }, 300);
        },

        scrollBottom(elem = 'main'){
            $(elem).animate({ scrollTop: $(elem).prop("scrollHeight")}, 750);
        },        
    },

    computed: {
        hasNoVideo(){
            return this.song.url == 'https://www.youtube.com/watch?v=soundfeed';
        },

        songPicture() {
            return this.song.id ? {'background-image': 'url('+ App.restApi + '/api/image/' + this.song.picture_path +')'} : {};
        },

        getGenres() {
            if (this.song.id){
                return $.isArray(this.song.genres) ? this.song.genres.join(" ") : this.song.genres;
            }else{
                return null;
            }
        },

        isLoaded() {
            return this.song.id ? true : false;
        },

        isReady() {
            return this.track.duration ? true : false;
        },

        isOwner() {
            return this.isLoaded ? App.user.id == this.song.uploader.id : false;
        },

        isArtist() {
            return this.isLoaded ? this.song.uploader.type == 'artist' : false;
        },

        isLabel() {
            return this.isLoaded ? this.song.uploader.type == 'label' : false;
        },

        uploaderUrl() {
            return '/profile/' + this.song.uploader.id;
        },        

        getSongEndpoint() {
            var endpoint = App.restApi + '/api/song/' + this.songId;

            if (this.disabled) {
                return endpoint + '?token=' + this.token;
            }

            return endpoint;
        },
 
        updatePickEndpoint() {
            return App.restApi + '/api/user/' + this.song.uploader.id + '/picks';
        },
 
        reviewEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/review';
        },
    },

    beforeDestroy() {
        this.$root.$off("currentSongStream", this.fnUpdateSeeker);
        this.$root.$off(['currentSongPlaying']);
    }      
}
</script>
